var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    flill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 8.21875C19.0625 8.53125 19.0625 9 18.75 9.28125L10.5 17.5312C10.2188 17.8438 9.75 17.8438 9.46875 17.5312L5.21875 13.2812C4.90625 13 4.90625 12.5312 5.21875 12.2188C5.5 11.9375 5.96875 11.9375 6.25 12.2188L10 15.9688L17.7188 8.21875C18 7.9375 18.4688 7.9375 18.75 8.21875Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.dd00f3b338513f61bbf41717a0806436.svg";
export { ForwardRef as ReactComponent };